import { CEDRUM_BRAND_LOGOS } from "./logos.js";
import "./BrandLogo.scss";

function classNames(...values) {
  return values.filter(Boolean).join(" ");
}

function normalizeVariant(variant) {
  return variant === "site" ? "site" : "app";
}

function normalizeSize(size) {
  return size === "nav" ? "nav" : "nav";
}

function normalizeAriaLabel(label) {
  const resolved = String(label || "").trim();
  return resolved || "cedrum";
}

function normalizeLockupMode(mode) {
  if (mode === "mark") return "mark";
  if (mode === "lockup") return "lockup";
  return "auto";
}

export function BrandLogo({
  variant = "app",
  href = "/",
  size = "nav",
  lockupMode = "auto",
  className = "",
  ariaLabel = "cedrum",
}) {
  const resolvedVariant = normalizeVariant(variant);
  const resolvedSize = normalizeSize(size);
  const resolvedLockupMode = normalizeLockupMode(lockupMode);
  const rootClassName = classNames(
    "cedrumBrandLogo",
    `cedrumBrandLogo--variant${resolvedVariant === "app" ? "App" : "Site"}`,
    `cedrumBrandLogo--size${resolvedSize === "nav" ? "Nav" : "Nav"}`,
    `cedrumBrandLogo--lockupMode${
      resolvedLockupMode === "lockup"
        ? "Lockup"
        : resolvedLockupMode === "mark"
          ? "Mark"
          : "Auto"
    }`,
    className,
  );

  const label = normalizeAriaLabel(ariaLabel);
  const lockupLight = CEDRUM_BRAND_LOGOS.lockup.light;
  const lockupDark = CEDRUM_BRAND_LOGOS.lockup.dark;
  const markLight = CEDRUM_BRAND_LOGOS.mark.light;
  const markDark = CEDRUM_BRAND_LOGOS.mark.dark;

  const content = (
    <>
      <span className="cedrumBrandLogo__slot cedrumBrandLogo__slot--lockup">
        <img
          className="cedrumBrandLogo__asset cedrumBrandLogo__asset--light"
          src={lockupLight}
          alt={label}
          decoding="async"
          loading="eager"
        />
        <img
          className="cedrumBrandLogo__asset cedrumBrandLogo__asset--dark"
          src={lockupDark}
          alt={label}
          decoding="async"
          loading="eager"
        />
      </span>
      <span className="cedrumBrandLogo__slot cedrumBrandLogo__slot--mark">
        <img
          className="cedrumBrandLogo__asset cedrumBrandLogo__asset--light"
          src={markLight}
          alt={label}
          decoding="async"
          loading="eager"
        />
        <img
          className="cedrumBrandLogo__asset cedrumBrandLogo__asset--dark"
          src={markDark}
          alt={label}
          decoding="async"
          loading="eager"
        />
      </span>
    </>
  );

  if (!href) {
    return (
      <span className={rootClassName} aria-label={label}>
        {content}
      </span>
    );
  }

  return (
    <a className={rootClassName} href={href} aria-label={label}>
      {content}
    </a>
  );
}
